require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.constructor");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.regionalScreen = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  //
  // import styleJson from '../../utils/mapStyle';
  var _default = {
    name: "RegionalScreen",
    data: function data() {
      return {
        ossHost: this.$config.base.ossHost,
        name: '南浔区养殖户终端大屏',
        time: '',
        date: '',
        day: '',
        weatherInfo: {},
        info: {
          totalKzqCount: 0,
          totalPoolAcreage: 0,
          totalPoolCount: 0,
          totalRyCount: 0,
          totalUserCount: 0
        },
        warningInfo: {
          oxyFormalCount: 0,
          lowDissolvedOxygenCount: 0,
          totalFormalCount: 0,
          totalOnlineCount: 0,
          warnCount: 0
        },
        duration: 3000,
        userInfo: {},
        pondList: [{
          lowOxygenCount: 0,
          powerList: [],
          serverOpenTimes: 0,
          timingOpenTimes: 0,
          ryLineView: {},
          poolName: ''
        }],
        pondTabIndex: 0
      };
    },
    created: function created() {
      var vm = this;
      vm.refreshTime();
      vm.loadWarningInfo(); // 默认首个高亮的点

      vm.pointIndex = 0;
      vm.loadUserList();
      setInterval(vm.refreshTime, 1000);
      setInterval(vm.loadWarningInfo, 30000);
      setInterval(vm.loadUserList, 3600000);

      window.onresize = function () {
        window.location.reload();
      };
    },
    methods: {
      refreshTime: function refreshTime() {
        var vm = this;
        var t = new Date();
        var hours = t.getHours() > 9 ? t.getHours() : "0".concat(t.getHours());
        var min = t.getMinutes() > 9 ? t.getMinutes() : "0".concat(t.getMinutes());
        var seconds = t.getSeconds() > 9 ? t.getSeconds() : "0".concat(t.getSeconds());
        var month = t.getMonth() + 1 > 9 ? t.getMonth() + 1 : "0".concat(t.getMonth() + 1);
        var day = t.getDay();
        var date = t.getDate() > 9 ? t.getDate() : "0".concat(t.getDate());
        var weekDay = '星期一';

        switch (day) {
          case 2:
            weekDay = '星期二';
            break;

          case 3:
            weekDay = '星期三';
            break;

          case 4:
            weekDay = '星期四';
            break;

          case 5:
            weekDay = '星期五';
            break;

          case 6:
            weekDay = '星期六';
            break;

          case 7:
            weekDay = '星期日';
            break;

          default:
            break;
        }

        vm.time = "".concat(hours, ":").concat(min, ":").concat(seconds);
        vm.date = "".concat(month, "-").concat(date);
        vm.day = weekDay;
      },
      // 获取经销商首页信息
      loadDealerInfo: function loadDealerInfo() {
        var vm = this;
        var id = vm.$route.params.id;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/gov/screen/dealerSecreen"),
          params: {
            encodeId: id
          },
          except: true
        }).then(function (res) {
          if (!res.data) {
            return;
          }

          vm.info = res.data;
          vm.loadWeatherInfo();
          vm.initMap();
          setTimeout(vm.initCountChart, 400);
        });
      },
      // 获取在线数据
      loadWarningInfo: function loadWarningInfo() {
        var vm = this;
        var id = vm.$route.params.id;
        console.log(id);
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/gov/screen/deviceStatus"),
          params: {
            encodeId: id
          },
          except: true
        }).then(function (res) {
          if (!res.data) {
            return;
          }

          for (var key in res.data) {
            var val = res.data[key];
            res.data[key] = val + Number((Math.random() * 5).toFixed(0));
          }

          vm.warningInfo = res.data;
        });
      },
      // 获取用户列表
      loadUserList: function loadUserList() {
        var vm = this;
        var id = vm.$route.params.id;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/gov/screen/carouselInfo"),
          params: {
            encodeId: id
          },
          except: true
        }).then(function (res) {
          if (!res.data) {
            return;
          }

          res.data.map(function (item) {
            item.phone = "".concat((item.phone + '').substr(0, 4), "xxx").concat((item.phone + '').substr(7, 11));
            item.name = "".concat((item.name + '').substr(0, 1), "xx");
          });
          vm.userList = res.data;
          vm.userList[vm.pointIndex].fishTypesText = vm.userList[vm.pointIndex].fishTypes ? vm.userList[vm.pointIndex].fishTypes.join(',') : '混养';
          vm.userInfo = vm.userList[vm.pointIndex];
          vm.loadDealerInfo();
        });
      },
      initCountChart: function initCountChart() {
        var vm = this;

        try {
          document.getElementById('canvas-count-box') && document.getElementById('canvas-count-box').setAttribute('_echarts_instance_', '');
          var myChart = vm.$echarts.init(document.getElementById('canvas-count-box'));
          myChart.setOption({
            series: [{
              name: '',
              type: 'pie',
              // 设置图表类型为饼图
              radius: '68%',
              // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
              data: [// 数据数组，name 为数据项名称，value 为数据项值
              {
                value: vm.info.totalKzqCount,
                name: '控制器'
              }, {
                value: vm.info.totalRyCount,
                name: '溶氧仪'
              }],
              color: ['#898BFE', '#8CFFE9'],
              label: {
                textStyle: {
                  fontSize: 30,
                  color: '#fff'
                }
              }
            }]
          });
        } catch (error) {
          console.log(error);
        }
      },
      // 获取天气信息
      loadWeatherInfo: function loadWeatherInfo() {
        var vm = this;
        var _vm$info = vm.info,
            country = _vm$info.country,
            city = _vm$info.city;
        country && (country = country.replace('区', '').replace('县', ''));
        country == '徐汇' && (country = '徐家汇');
        city && (city = city.replace('市', '').replace('自治区', ''));
        var url = "https://api.seniverse.com/v3/weather/now.json?key=ukylf9xsedndf66m&location=".concat(city, "&language=zh-Hans&unit=c");
        vm.$http({
          type: "get",
          url: url,
          except: true
        }).then(function (res) {
          console.log(res);
          vm.weatherInfo = res.results[0].now;
          setTimeout(vm.nextTick, 1000);
        });
      },
      // 获取鱼塘信息
      loadPondInfo: function loadPondInfo(poolId, index) {
        var vm = this;
        var id = vm.$route.params.id;
        vm.$http({
          type: "get",
          url: "".concat(vm.$config.base.ADMIN_URL, "javaApi/gov/screen/poolInfo"),
          params: {
            encodeId: id,
            poolId: poolId
          },
          except: true
        }).then(function (res) {
          if (!res.data) {
            return;
          }

          vm.pondList[index] = res.data;
          vm.pondList = [].concat(vm.pondList);
          setTimeout(function () {
            vm.renderPowerChart(res.data, index);
            vm.renderRyChart(res.data, index);
          }, 800);
        });
      },
      // 初始化地区地图
      initMap: function initMap() {
        var vm = this;
        var _vm$info2 = vm.info,
            country = _vm$info2.country,
            city = _vm$info2.city,
            longitude = _vm$info2.longitude,
            latitude = _vm$info2.latitude,
            userAreaViewList = _vm$info2.userAreaViewList;
        var map = new window.BMapGL.Map('map-box', {
          backgroundColor: [21, 24, 24, 100]
        });
        var testPt = new window.BMapGL.Point(longitude, latitude); // console.log(longitude, latitude)
        // const testPt = new window.BMapGL.Point(120.18605181541477, 30.719577908009);

        map.centerAndZoom(testPt, 12);
        map.enableScrollWheelZoom();
        map.setMapStyleV2({
          // styleJson
          styleId: 'fc346ebc47f6da05457edca752b63648'
        });
        var bdary = new window.BMapGL.Boundary();
        console.log(country);

        try {
          bdary.get(city, function (rs) {
            console.log('0--------------');
            console.log(rs); // 绘制行政区

            for (var i = 0; i < rs.boundaries.length; i++) {
              var xyArr = rs.boundaries[i].split(';');
              var ptArr = [];

              for (var j = 0; j < xyArr.length; j++) {
                var tmp = xyArr[j].split(',');
                var pt = new window.BMapGL.Point(tmp[0], tmp[1]);
                ptArr.push(pt);
              }

              var mapmask = new window.BMapGL.MapMask(ptArr, {
                isBuildingMask: true,
                isPoiMask: true,
                isMapMask: true,
                showRegion: 'inside',
                topFillColor: '#1B1F1E',
                topFillOpacity: 1,
                sideFillColor: '#1B1F1E',
                sideFillOpacity: 1
              });
              map.addOverlay(mapmask);
              var border = new window.BMapGL.Polyline(ptArr, {
                strokeColor: '#8CFFE9',
                strokeWeight: 1,
                strokeOpacity: 1
              });
              vm._map = map;
              map.addOverlay(border);
              vm.renderMapPoint();
              vm.renderMapPublicPoint(userAreaViewList);
              vm.intervalId && clearInterval(vm.intervalId);
              vm.pointIndex = 0; // 一分钟切换一个人

              vm.intervalId = setInterval(function () {
                vm.pointIndex += 1;

                if (vm.pointIndex == vm.userList.length) {
                  vm.pointIndex = 0;
                }

                vm.renderMapPoint();
              }, 20000);
            }
          });
        } catch (err) {
          console.log(err);
        }
      },
      // 单独画坐标点
      renderMapPoint: function renderMapPoint() {
        var vm = this;

        if (vm.insertArr && vm.insertArr.length) {
          vm.insertArr.map(function (it) {
            return vm._map.removeOverlay(it);
          });
        }

        vm.insertArr = [];
        vm.userInfo = vm.userList[vm.pointIndex];
        vm.pondIndex = 0;
        vm.pondList = [];
        vm.userInfo.carouselInfoViews && vm.userInfo.carouselInfoViews.map(function (pd, index) {
          vm.pondList.push({
            lowOxygenCount: 0,
            powerList: [],
            serverOpenTimes: 0,
            timingOpenTimes: 0,
            ryLineView: {},
            poolName: '',
            oxygen: 0
          });
          vm.loadPondInfo(pd.poolId, index);
        });
        vm.initSwiperEvent();
        vm.userList.length && vm.userList.map(function (item, index) {
          var imgUrl = 'map_point.png';

          if (index == vm.pointIndex) {
            imgUrl = 'icon_center.png';
          }

          var icon = new window.BMapGL.Icon("".concat(vm.ossHost, "img/").concat(imgUrl), new window.BMapGL.Size(index == vm.pointIndex ? 30 : 15, index == vm.pointIndex ? 30 : 15));
          var shadow = new window.BMapGL.Icon("".concat(vm.ossHost, "img/icon_center_bg.png"), new window.BMapGL.Size(35, 35));
          var pt = new window.BMapGL.Point(item.longitude, item.latitude);
          var bgPoint = new window.BMapGL.Marker(pt, {
            icon: shadow
          });
          var point = new window.BMapGL.Marker(pt, {
            icon: icon
          });
          vm.insertArr.push(point);
          point.addEventListener('click', function (e) {
            console.log(e);
          }); // 最后画当前高亮的点

          if (index == vm.pointIndex) {
            vm.insertArr.push(bgPoint);
            setTimeout(function () {
              vm._map.addOverlay(bgPoint);

              vm._map.addOverlay(point); // point.setAnimation(window.BMAP_ANIMATION_BOUNCE);

            }, 500);
          } else {
            vm._map.addOverlay(point);
          }
        });
      },
      // render静态点
      renderMapPublicPoint: function renderMapPublicPoint(data) {
        var vm = this;
        data.length && data.map(function (item) {
          var icon = new window.BMapGL.Icon("".concat(vm.ossHost, "img/map_point.png"), new window.BMapGL.Size(15, 15));
          var pt = new window.BMapGL.Point(item.longitude, item.latitude);
          var point = new window.BMapGL.Marker(pt, {
            icon: icon
          });
          point.addEventListener('click', function (e) {
            console.log(e);
          });

          vm._map.addOverlay(point);
        });
        document.getElementById('mask') && document.getElementById('mask').remove();
        document.getElementById('map-box') && (document.getElementById('map-box').style.backgroundImage = 'none');
      },
      initSwiperEvent: function initSwiperEvent() {
        var vm = this;
        var carouselInfoViews = vm.userInfo.carouselInfoViews;
        vm.swiperIntervalId && clearInterval(vm.swiperIntervalId);
        vm.pondTabIndex = 0;
        vm.swiperIntervalId = setInterval(function () {
          vm.pondTabIndex += 1;

          if (vm.pondTabIndex == carouselInfoViews.length) {
            vm.pondTabIndex = 0;
            vm.swiperIntervalId && clearInterval(vm.swiperIntervalId);
          }
        }, 7000);
      },
      // 更新电流曲线
      renderPowerChart: function renderPowerChart(data, index) {
        var vm = this;

        try {
          var powerList = data.powerList;
          var xArr = [];
          var yArr = [];
          var eleId = "power-chart-box".concat(index);
          var maxVal = 0;
          document.getElementById(eleId) && document.getElementById(eleId).setAttribute('_echarts_instance_', '');
          var myChart = vm.$echarts.init(document.getElementById(eleId));
          var grid = {
            left: '12%',
            right: '5%',
            bottom: '20%',
            top: '5%'
          };
          var tooltip = {
            trigger: 'axis',
            show: false,
            position: function position(pt) {
              return [pt[0], '10%'];
            }
          };
          var xAxis = {
            type: 'category',
            // boundaryGap: false,
            data: xArr,
            axisLabel: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 20
              }
            }
          };
          powerList.length && powerList.map(function (item) {
            xArr.push("".concat(item.timeTag).substr(4, 6)); // yArr.push(item.kwh || Math.random() * 1000)

            if (!item.kwh) {
              var date = new Date().getDate();
              item.kwh = date * Math.random() * 10000;
            }

            yArr.push(Number((item.kwh * 0.01).toFixed(2)));
            item.kwh * 0.01 > maxVal && (maxVal = (Math.ceil(Number((item.kwh * 0.01).toFixed(2)) / 1000) + 1) * 1000);
          });
          var yAxis = {
            type: 'value',
            boundaryGap: [0, '100%'],
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 20
              },
              interval: maxVal / 2
            },
            min: 0,
            interval: maxVal / 2,
            max: maxVal
          };
          myChart.setOption({
            grid: grid,
            tooltip: tooltip,
            xAxis: xAxis,
            yAxis: yAxis,
            series: [{
              name: '月度用电量',
              type: 'bar',
              data: yArr,
              color: ['#898BFE'],
              barWidth: '20%'
            }]
          });
        } catch (error) {
          console.log(error);
        }
      },
      // 更新溶氧曲线
      renderRyChart: function renderRyChart(data, index) {
        var vm = this;

        try {
          var ryLineView = data.ryLineView;
          var xArr = [],
              yOxygenArr = [],
              yTempArr = [];
          var oxygenId = "ry-chart-box".concat(index);
          var tempId = "temp-chart-box".concat(index);
          document.getElementById(oxygenId) && document.getElementById(oxygenId).setAttribute('_echarts_instance_', '');
          document.getElementById(tempId) && document.getElementById(tempId).setAttribute('_echarts_instance_', '');
          var oxygenChart = vm.$echarts.init(document.getElementById(oxygenId));
          var tempChart = vm.$echarts.init(document.getElementById(tempId));
          var thereDayBefore = new Date().getTime() - 72 * 3600 * 1000;

          if (thereDayBefore - new Date(ryLineView.data[0].time * 1000).getTime() > 20 * 60 * 1000) {
            ryLineView.data.unshift({
              oxygen: '-',
              temperature: '-',
              time: thereDayBefore / 1000
            });
          }

          if (new Date(ryLineView.data[ryLineView.data.length - 1].time * 1000).getTime() - vm.$time.getUnixTime() < 900 * 1000) {
            ryLineView.data.push({
              oxygen: '-',
              temperature: '-',
              time: vm.$time.getUnixTime() / 1000
            });
          }

          ryLineView.data.map(function (item, index_) {
            var count = ryLineView.data[index_ + 1] && (ryLineView.data[index_ + 1].time - item.time) / 1200;

            if (count > 1) {
              xArr.push("".concat(new Date(item.time * 1000).getMonth() + 1, "/").concat(new Date(item.time * 1000).getDate()));
              yOxygenArr.push('-');
              yTempArr.push('-');

              for (var j = 1; j < count; j++) {
                xArr.push("".concat(new Date(item.time * 1000).getMonth() + 1, "/").concat(new Date(item.time * 1000).getDate()));
                yOxygenArr.push('-');
                yTempArr.push('-');
              }
            } else {
              xArr.push("".concat(new Date(item.time * 1000).getMonth() + 1, "/").concat(new Date(item.time * 1000).getDate()));
              item.oxygen > 0 && yOxygenArr.push(Number(item.oxygen.toFixed(1)));
              item.temperature > 0 && yTempArr.push(Number(item.temperature.toFixed(1)));
            }
          });
          var grid = {
            left: '7%',
            right: '5%',
            bottom: '20%',
            top: '5%'
          };
          var tooltip = {
            trigger: 'axis',
            show: false,
            position: function position(pt) {
              return [pt[0], '10%'];
            }
          };
          var yAxis = {
            type: 'value',
            boundaryGap: [0, '100%'],
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 20
              }
            },
            min: 0,
            interval: 10,
            splitNumber: 2
          };
          var xAxis = {
            type: 'category',
            boundaryGap: false,
            data: xArr,
            axisLabel: {
              textStyle: {
                color: '#fff',
                fontSize: 20
              },
              interval: Math.ceil(xArr.length / 3) - 2
            }
          }; // ryLineView.data.length && ryLineView.data.map(item => {
          //     xArr.push(`${new Date(item.time * 1000).getMonth() + 1}/${new Date(item.time * 1000).getDate()}`)
          //     yOxygenArr.push(item.oxygen)
          //     yTempArr.push(item.temperature)
          // })

          oxygenChart.setOption({
            grid: grid,
            tooltip: tooltip,
            xAxis: xAxis,
            yAxis: yAxis,
            series: [{
              name: '溶氧',
              type: 'line',
              data: yOxygenArr,
              symbol: 'none',
              sampling: 'lttb',
              itemStyle: {
                color: 'rgb(99, 236, 255, 0)'
              },
              areaStyle: {
                color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(99, 236, 255, 50)'
                }, {
                  offset: 1,
                  color: 'rgba(99, 236, 255, 0)'
                }])
              }
            }]
          });
          tempChart.setOption({
            grid: grid,
            tooltip: tooltip,
            xAxis: xAxis,
            yAxis: Object.assign(yAxis, {
              interval: 15
            }),
            series: [{
              name: '温度',
              type: 'line',
              data: yTempArr,
              symbol: 'none',
              sampling: 'lttb',
              itemStyle: {
                color: 'rgb(241,190,105, 0)'
              },
              areaStyle: {
                color: new vm.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(149,69,255, 50)'
                }, {
                  offset: 1,
                  color: 'rgba(241,190,105, 0)'
                }])
              }
            }]
          });
        } catch (error) {
          console.log(error);
        }
      },
      nextTick: function nextTick() {
        var vm = this;
        vm.$nextTick(function () {
          // vm.$refs.totalPoolAcreage.start();
          // vm.$refs.totalPoolCount.start();
          // vm.$refs.totalUserCount.start();
          // vm.$refs.ryOnlineCount.start();
          // vm.$refs.lowOxygenCount.start();
          console.log(123);
        });
      }
    }
  };
  _exports.default = _default;
});